import palette from 'src/designSystem/variables/palette'
import styled from 'styled-components/macro'
import {
  ShowPageContainer,
  ShowPageItemContainer,
} from 'src/components/PageLayout/ShowPage'

export const StyledModelId = styled.div`
  word-break: break-all;
  overflow: hidden;
  text-overflow: ellipsis;
`

export const RESULT_TAB_GRID_COLUMNS =
  'min-content 1fr repeat(4, auto) 186px repeat(2, min-content)'

export const LinkagesMenuContainer = styled.div`
  display: flex;
  flex-direction: column;
  border: 1px solid ${palette.neutral[100]};
  border-radius: 16px;
  width: 400px;
`
export const LinkagesMenuBody = styled.div`
  padding: 24px;
  display: flex;
  flex-direction: column;
  gap: 12px;
`

export const ControlsShowPageContainer = styled(ShowPageContainer)`
  display: flex;
  flex-direction: column;
  height: auto;
  flex-grow: 1;
`

export const ControlsShowPageItemContainer = styled(ShowPageItemContainer)`
  height: 100%;
`
